import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { flagMessage } from 'actions/conversation';
import { getReaderParameters } from 'actions/user';
import { trackImmersiveReaderError } from 'helpers/insights';
import moment from 'moment';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import swal from 'sweetalert2';
import { Spinner } from 'UI';
import DateTime from '_class/DateTime';
import Message from './Partials/Message';

var ImmersiveReader = require('@microsoft/immersive-reader-sdk');

var ConversationMessages = /*#__PURE__*/function (_Component) {
  _inherits(ConversationMessages, _Component);

  var _super = _createSuper(ConversationMessages);

  /* Class setup */
  function ConversationMessages(props) {
    var _this;

    _classCallCheck(this, ConversationMessages);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setContainer", function (element) {
      _this.container = element;
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.container.removeEventListener('scroll', _this.onScroll);

      ImmersiveReader.close();
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      // Get messages (page 1)
      var conversation = _this.props.conversation;

      if (_this.container != null) {
        _this.container.scrollTop = _this.container.scrollHeight;

        _this.container.addEventListener('scroll', _this.onScroll);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps, prevState) {
      if (prevState != _this.state) {
        return;
      }

      _this.container.scrollTop = _this.container.scrollHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "throttle", function (func, immediate) {
      return function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var later = function later() {
          this.timeout = null;
          if (!immediate) func.apply(this, args);
        };

        var callNow = immediate && !_this.timeout;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(later, _this.scrollLimit);
        if (callNow) func.apply(_assertThisInitialized(_this), args);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "loadMore", function () {
      var onScrollComplete = _this.throttle(function () {
        if (!_this.state.loadingMore) {
          _this.setState({
            loadingMore: true
          });

          console.log('load next page');
        }
      });

      onScrollComplete();
    });

    _defineProperty(_assertThisInitialized(_this), "getUserById", function (id) {
      if (_this.props.conversation != null) {
        var membership = _this.props.conversation.memberships.find(function (membership) {
          return membership.membershipID == id;
        });

        if (membership != null) {
          return _objectSpread({
            id: membership.membershipID
          }, membership.user);
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "runImmersiveReader", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(message) {
        var _this$props, user, translate, localLanguage, creator, name, time, owner_section, _owner_section$sectio, data, reader;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = _this.props, user = _this$props.user, translate = _this$props.translate;
                localLanguage = localStorage.getItem('language');
                creator = _this.getUserById(message.creator);
                name = '';
                time = new DateTime(message.created).getLongDateWithTime();

                if (message.senderId != null && message.senderType == 'SECTION') {
                  owner_section = _this.props.conversation.memberships.find(function (m) {
                    return m.membershipID == message.senderId;
                  });

                  if (owner_section != null) {
                    name = (_owner_section$sectio = owner_section.section) === null || _owner_section$sectio === void 0 ? void 0 : _owner_section$sectio.title;
                  }
                } else {
                  name = creator.firstName + ' ' + creator.lastName;
                }

                data = {
                  title: name,
                  chunks: [{
                    content: name + ', ' + time + '<br /><br />',
                    mimeType: 'text/html'
                  }, {
                    content: message.text,
                    mimeType: 'text/html'
                  }]
                };
                _context.next = 9;
                return _this.props.getReaderParameters();

              case 9:
                reader = _this.props.reader;

                if (!(reader == null)) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return");

              case 12:
                ImmersiveReader.launchAsync(reader.token, reader.subdomain, data, {
                  uiLang: localLanguage,
                  // Set immersive reader UI language to selected lang in Haldor Edu
                  uiZIndex: 9147483
                })["catch"](function (error) {
                  console.error('error', error);
                  trackImmersiveReaderError(error, user.id);
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "getMessages", function () {});

    _defineProperty(_assertThisInitialized(_this), "onScroll", function (event) {
      if (_this.container.scrollTop < 10) {
        _this.loadMore();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "reportMessage", function (message) {
      var translate = _this.props.translate;
      swal.fire({
        title: translate('Report message as inappropriate'),
        text: translate('Why do you want to report this message?'),
        input: 'text',
        showCancelButton: true,
        cancelButtonText: translate('Cancel'),
        confirmButtonText: translate('Report message')
      }).then(function (response) {
        if (response.value != null) {
          _this.props.flagMessage(message.id, response.value).then(function () {
            swal.fire({
              title: translate('The message has been reported'),
              text: translate('The message will be hidden while waiting for an administrator to manage the report.'),
              showCancelButton: false,
              confirmButtonText: 'Okay'
            });
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderMessage", function (message, index) {
      var user = _this.props.user;
      var me = false;
      var narrow = false;
      var up = false;
      var down = false;
      var newMessage = false;
      var actions = [];
      var flagged = null;

      if (message.creator == user.id) {
        me = true;

        if (message.flagID != null) {
          flagged = _this.props.translate('Message is reported as inappropriate.');
        }
      } else {
        if (message.flagID == null) {
          actions.push({
            label: _this.props.translate('Report message'),
            onClick: function onClick() {
              return _this.reportMessage(message);
            }
          });
        } else {
          flagged = _this.props.translate('Message is reported as inappropriate.');
        }
      }

      if (_this.props.services.immersiveReaderConversations) {
        actions.push({
          label: _this.props.translate('immersive-reader'),
          onClick: function onClick() {
            return _this.runImmersiveReader(message);
          }
        });
      }

      if (moment(message.created) > moment(_this.props.conversation.lastRead) && !me) {
        newMessage = true;
      }

      var lastMessage = _this.props.conversation.messages[index - 1];

      if (lastMessage != null && lastMessage.creator == message.creator) {
        narrow = true;
        up = true;
      }

      var sender = '';

      var creator = _this.getUserById(message.creator);

      var nextMessage = _this.props.conversation.messages[index + 1];

      if (nextMessage != null) {
        if (nextMessage.creator == message.creator) {
          down = true;
        }
      }

      if (message.senderId != null && message.senderType == 'SECTION') {
        var owner_section = _this.props.conversation.memberships.find(function (m) {
          return m.membershipID == message.senderId;
        });

        if (owner_section != null) {
          var _owner_section$sectio2;

          sender = (_owner_section$sectio2 = owner_section.section) === null || _owner_section$sectio2 === void 0 ? void 0 : _owner_section$sectio2.title;
        }
      } else {
        sender = creator.firstName + ' ' + creator.lastName;
      }

      return /*#__PURE__*/React.createElement(Message, {
        key: message.id,
        actions: actions,
        time: message.created,
        multipleUp: up,
        multipleDown: down,
        narrow: narrow,
        sender: sender,
        me: me,
        "new": newMessage,
        children: message.text,
        flagged: flagged,
        messageId: message.id
      });
    });

    _this.state = {
      loadingMore: false,
      loading: true
    };
    _this.container = null;
    _this.event = null;
    _this.scrollLimit = 35;
    _this.timeout = null;
    return _this;
  }

  _createClass(ConversationMessages, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "conversation messages-container",
        ref: this.setContainer
      }, /*#__PURE__*/React.createElement("div", {
        className: "__inner"
      }, this.props.conversation != null ? this.props.conversation.messages.map(this.renderMessage) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })));
    }
  }]);

  return ConversationMessages;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    user: state.user.currentUser,
    services: state.Services.availableServices,
    messages: state.Conversation.messages,
    reader: state.user.reader
  };
}

export default connect(mapStateToProps, {
  flagMessage: flagMessage,
  getReaderParameters: getReaderParameters
})(ConversationMessages);